import React from 'react';
import styled from 'styled-components';

interface DropDownWrapperProps {
  position: 'left' | 'right';
}

const DropDownWrapper = styled.div<DropDownWrapperProps>`
  position: absolute;
  background-color: var(--way-palette-white-100);
  box-shadow: var(--way-design-boxShadow-l);
  ${({ position }) => position}: 0;
  top: 115%;
  z-index: 999999;
`;

interface DropDownContainerProps {
  ariaLabel?: string;
  children: React.ReactNode;
  dropDownRef: React.RefObject<HTMLDivElement>;
  position: 'left' | 'right';
  role?: string;
}

const DropDownContainer = ({
  ariaLabel,
  children,
  dropDownRef,
  position,
  role,
}: DropDownContainerProps) => {
  return (
    <DropDownWrapper
      aria-label={ariaLabel}
      position={position}
      ref={dropDownRef}
      role={role}
    >
      {children}
    </DropDownWrapper>
  );
};

export default DropDownContainer;
